import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/_layout/attendance/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/attendance/shifts" });
  },
});
